import { createAnimations as createAnimationsCSS } from "@tamagui/animations-css";
import { animations as animationsCSS } from "@tamagui/config/v5-css";
const tooltip = "450ms cubic-bezier(0.25, 1.25, 0.5, 1)";
const animations = createAnimationsCSS({
  ...animationsCSS.animations,
  tooltip
});
export { animations };
//# sourceMappingURL=animations.mjs.map
